import { BOOTH_POSITIONS } from "../configs/BOOTH_POSITIONS";

export const calculateBoothRotations = () => {
  const values = BOOTH_POSITIONS;
  const boothRotationsArray = values.map((value) => value.rotation);
  return boothRotationsArray;
};
